import { reactive } from 'vue'
import type { PostItem, TagItem, CategoryItem } from '@/types'

const postsState = reactive({
  posts: [] as PostItem[],
  tags: [] as TagItem[],
  categories: [] as CategoryItem[]
})

export function usePosts() {
  function setPosts(posts: PostItem[]) {
    postsState.posts = posts
  }

  function setTags(tags: TagItem[]) {
    postsState.tags = tags
  }

  function setCategories(categories: CategoryItem[]) {
    postsState.categories = categories
  }

  function clearAll() {
    postsState.posts = []
    postsState.tags = []
    postsState.categories = []
  }

  return {
    postsState,
    setPosts,
    setTags,
    setCategories,
    clearAll
  }
}
